/* Testimonial Spotlight — word-blur reveal, lerped cursor bubble, click-anywhere
   advance, per-quote star ratings. Quote area uses natural height with a FLIP
   height transition between testimonials: measure out, swap, measure in, glide,
   release to auto. Wordy quotes (>26 words) get the .ts-long size step-down. */
(function () {
  'use strict';
  if (window.__tsSpotlightInit) return;
  window.__tsSpotlightInit = true;

  var FINE_POINTER = window.matchMedia('(pointer: fine)').matches;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LONG_WORDS = 26;

  function init(root) {
    if (root.dataset.tsReady === 'true') return;
    root.dataset.tsReady = 'true';

    var quotes = Array.prototype.map.call(
      root.querySelectorAll('[data-ts-quote-src]'),
      function (el) { return el.textContent.trim(); }
    );
    if (!quotes.length) return;

    var frame = root.querySelector('[data-ts-frame]');
    var bq = root.querySelector('[data-ts-quote]');
    var authors = root.querySelectorAll('[data-ts-author]');
    var avatars = root.querySelectorAll('[data-ts-avatar]');
    var minis = root.querySelectorAll('[data-ts-mini]');
    var stars = root.querySelectorAll('[data-ts-stars]');
    var counter = root.querySelector('[data-ts-counter]');
    var bar = root.querySelector('[data-ts-bar]');
    var idx = 0;
    var total = quotes.length;

    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function isLong(text) { return text.split(/\s+/).length > LONG_WORDS; }

    function renderQuote(text) {
      bq.classList.toggle('ts-long', isLong(text));
      bq.textContent = '';
      text.split(/\s+/).forEach(function (word, i) {
        var s = document.createElement('span');
        s.className = 'ts-word';
        s.textContent = word;
        if (!REDUCED) s.style.animationDelay = (i * 30) + 'ms';
        bq.appendChild(s);
        bq.appendChild(document.createTextNode(' '));
      });
    }

    /* FLIP the frame height: old px -> new px, release to auto when done. */
    function swapQuote(text, animate) {
      if (!frame || !animate || REDUCED) {
        renderQuote(text);
        return;
      }
      var startH = frame.offsetHeight;
      frame.style.height = '';           /* natural, so the new content sets it  */
      renderQuote(text);
      var endH = frame.offsetHeight;
      if (endH === startH) return;       /* same height — nothing to glide       */
      frame.style.height = startH + 'px';
      void frame.offsetHeight;           /* commit start height before the move  */
      frame.classList.add('ts-animating');
      frame.style.height = endH + 'px';
    }

    if (frame) {
      frame.addEventListener('transitionend', function (e) {
        if (e.propertyName === 'height') {
          frame.style.height = '';
          frame.classList.remove('ts-animating');
        }
      });
    }

    function toggle(list, key, active) {
      Array.prototype.forEach.call(list, function (el) {
        el.classList.toggle('is-active', el.getAttribute(key) === String(active));
      });
    }

    function show(n, animate) {
      idx = ((n % total) + total) % total;
      swapQuote(quotes[idx], animate !== false);
      toggle(authors, 'data-ts-author', idx);
      toggle(avatars, 'data-ts-avatar', idx);
      toggle(minis, 'data-ts-mini', idx);
      toggle(stars, 'data-ts-stars', idx);
      if (counter) {
        counter.textContent = pad(idx + 1);
        counter.style.animation = 'none';
        void counter.offsetWidth;
        counter.style.animation = '';
      }
      if (bar) bar.style.width = (((idx + 1) / total) * 100) + '%';
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      show(idx + 1);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
    });

    /* cursor bubble — fine pointers, motion allowed */
    var cursor = root.querySelector('[data-ts-cursor]');
    if (cursor && FINE_POINTER && !REDUCED) {
      root.classList.add('ts-cursor-on');
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, inside = false;

      function loop() {
        cx += (tx - cx) * 0.16;
        cy += (ty - cy) * 0.16;
        cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px) translate(-50%,-50%)';
        if (inside || Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) {
          raf = requestAnimationFrame(loop);
        } else {
          raf = null;
        }
      }

      root.addEventListener('mousemove', function (e) {
        var r = root.getBoundingClientRect();
        tx = e.clientX - r.left;
        ty = e.clientY - r.top;
        if (raf === null) raf = requestAnimationFrame(loop);
      });
      root.addEventListener('mouseenter', function (e) {
        inside = true;
        var r = root.getBoundingClientRect();
        cx = tx = e.clientX - r.left;
        cy = ty = e.clientY - r.top;
        root.classList.add('ts-hovered');
        if (raf === null) raf = requestAnimationFrame(loop);
      });
      root.addEventListener('mouseleave', function () {
        inside = false;
        root.classList.remove('ts-hovered');
      });
    }

    show(0, false);
  }

  function initAll() {
    document.querySelectorAll('[data-testimonial-spotlight]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
